function setUnderlineStyling(element, styles) {
  if (styles.offset !== undefined) {
    element.style.setProperty("--underline--offset", `${styles.offset}px`);
  }
  if (styles.size !== undefined) {
    element.style.setProperty("--underline--size", `${styles.size}px`);
    element.style.setProperty("--underline--opacity", styles.size === 0 ? "0" : "1");
  }
  if (styles.translateTransitionDuration !== undefined) {
    element.style.setProperty("--underline--translate-transition-duration", `${styles.translateTransitionDuration}ms`);
  }
  if (styles.sizeTransitionDuration !== undefined) {
    element.style.setProperty("--underline--size-transition-duration", `${styles.sizeTransitionDuration}ms`);
  }
}

export { setUnderlineStyling };
//# sourceMappingURL=setUnderlineStyling.js.map
